import {
  PromoCodeResponseDto,
  PromoCodeResponseDtoError,
  PromoCodeResponseDtoSuccess,
} from ".";

export const isPromoCodeSuccessResponse = (
  data: PromoCodeResponseDto,
): data is PromoCodeResponseDtoSuccess => {
  return PromoCodeResponseDtoSuccess.safeParse(data).success;
};

export const isPromoCodeErrorResponse = (
  data: PromoCodeResponseDto,
): data is PromoCodeResponseDtoError => {
  return PromoCodeResponseDtoError.safeParse(data).success;
};
